// extracted by mini-css-extract-plugin
export default {"heading":"widget-header-module--heading--3Yp31","link":"widget-header-module--link--2xQD3","subtext":"widget-header-module--subtext--_ifv4"};